import React from "react";
import { DefaultText } from "theme/GlobalElements";
import { MdShoppingCart } from "react-icons/md";
import { headerButtonStyles } from "../../components/AppHeader/Desktop/styled";
import styled from "styled-components/macro";
import { bgFade } from "theme/Animations";
import CartDropdownData from "./CartDropdownData";
import { selectCartReload, updateCartData } from "./cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineShoppingCart } from "react-icons/hi";
import { toRem } from "theme/Breakpoints";
import userStorage from "store/UserStorage";
import { ProductCartItem } from "./types";

const DesktopCartButton = () => {
  const dispatch = useDispatch();

  const reload = useSelector(selectCartReload);
  const count = userStorage.selectTotalSelectedItems();
  const cartItems = userStorage.getStoredInCart();

  const onClick = () => {
    console.log("show cart");
  };

  const updateData = (newProductCardItems: any) => {
    dispatch(updateCartData([...newProductCardItems]));
  };

  const removeElementWithId = (id: string) => {
    if (cartItems.length !== 0) {
      let newListedItems = [...cartItems];
      let element = cartItems.find(
        (c: ProductCartItem) => c.product._id === id
      );
      if (element) {
        let index = cartItems.indexOf(element);
        newListedItems.splice(index, 1);
        updateData([...newListedItems]);
      }
    }
  };

  return (
    <Container>
      <HeaderButton onClick={onClick}>
        <MdShoppingCart color="white" size="1.5em" />
        <DefaultText fontSize={16} color="white">
          Количка
        </DefaultText>
      </HeaderButton>
      <DropdownDataContainer>
        <DataWrapper>
          <CartDropdownData
            listedItems={cartItems}
            emptyMessage="Количката ви е празна!"
            actionButtonTitle="Към количката"
            actionRoute="/cart"
            actionButtonIcon={
              <HiOutlineShoppingCart
                style={{
                  width: 24,
                  height: 24,
                  color: "white",
                  marginRight: "5px",
                }}
              />
            }
            removeElementWithId={removeElementWithId}
          />
        </DataWrapper>
      </DropdownDataContainer>
      <Counter>
        <DefaultText color={"white"}>{count}</DefaultText>
      </Counter>
    </Container>
  );
};
const Container = styled.div`
  cursor: pointer;
  position: relative;
  display: inline-block;
`;

const HeaderButton = styled.div`
  ${headerButtonStyles}
`;

export const DropdownDataContainer = styled.div`
  position: absolute;
  min-width: 160px;
  right: 0;
  z-index: 10;
  display: none;

  ${Container}:hover & {
    animation: ${bgFade} 0.3s ease-out;
    display: block;
  }
`;

export const DataWrapper = styled.div`
  width: ${toRem(400)};
  margin-top: 12px;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);

  &::before {
    content: "";
    border-style: solid;
    border-width: 10px 10px 10px 20px;
    border-color: transparent #fff transparent transparent;
    position: absolute;
    transform: rotate(90deg);
    top: -10px;
    right: 10px;
  }
`;

export const Counter = styled.div`
  position: absolute;
  display: flex;
  width: 20px;
  height: 20px;
  background-color: red;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  color: white;
  top: -10px;
  right: 0;
`;
export default DesktopCartButton;
